import { AddToCartButton } from '@/components/orders/AddToCartButton';
import { usePropertyCart } from '../PropertyCartContext';
import type { PropertyTable } from '../metadata/propertyConfig';

/**
 * Frozen-right table cell mirroring the New Order drawer's add-to-cart CTA.
 * Reads live cart/in-flight state from PropertyCartContext so the idle →
 * adding → added transitions stay in sync with the rest of the list (the
 * card grid gets the same state through render props).
 */
export function PropertyAddToCartCell({ row }: { row: PropertyTable }) {
  const { addingPropertyId, propertyIdsInCart, onAddToCart } = usePropertyCart();
  return (
    <AddToCartButton
      size="sm"
      isAdding={addingPropertyId === row.id}
      isAdded={propertyIdsInCart.has(row.id)}
      onAddToCart={(e) => {
        e.stopPropagation();
        onAddToCart(row);
      }}
      className="w-full"
    />
  );
}
